<template>
  <v-form
    ref="form"
    v-model="isValidationOk"
    lazy-validation>
    <v-container
      py-0
      fill-height
      fluid
      grid-list-xl>
      <v-layout
        wrap>
        <v-flex
          xs12
          md4>
          <MaglinkComponentLldList
            :loading="progressBar.loading"
            :filters="filters"
            :llds="llds"/>
        </v-flex>
        <v-flex
          xs12
          md2>
          <MaglinkComponentDatePicker
            :component-key="1"
            :rules-is-date="rules.isDate"
            :initial-date="dateFromToday(0)"
            :date-label="getDateLabel('Day')"
            :date-format="systemSettings.dateFormat"
            :max-date="maxDate"
            :loading="progressBar.loading"
            :clear-date="false"
            @getDate="onGetDate"
            @checkDates="onCheckDates"/>
        </v-flex>
        <v-flex
          v-show="isZoneDifferent"
          xs12
          md3>
          <span
            class="caption grey--text font-weight-light">
            {{ $t('Time zone') }}
          </span>
          <v-radio-group
            v-model.number="reportZone"
            :row="true">
            <v-radio
              v-for="(element, index) in reportZones"
              :key="index"
              :label="`${ element.desc }`"
              :value="element.code"
              @change="onChangeZone"/>
          </v-radio-group>
        </v-flex>
        <v-flex
          xs6
          md1
          text-xs-center>
          <v-btn
            :disabled="!isValidationOk || progressBar.loading"
            small
            class="mx-0 font-weight-light"
            color="dover-blue"
            @click="applyFilter">
            {{ $t('Load') }}
          </v-btn>
        </v-flex>
        <v-flex
          xs6
          md1
          text-xs-center>
          <MaglinkComponentCsvExportButton
            :is-validation-ok="isValidationOk"
            :loading="progressBar.loading"
            @csvExport="csvExport" />
        </v-flex>
        <v-flex
          xs12
          md12
          text-xs-left>
          <span
            class="caption grey--text font-weight-bold">
            {{ $t('Report type') }}
          </span>
          <br>
          <v-btn-toggle
            v-model="filters.type"
            dense
            group
            mandatory
            @change="onChangeReportType()">
            <v-btn
              v-for="(item) in reportTypes"
              :key="item.id"
              :value="item.id"
              text
              small
              color="dover-blue">
              {{ item.desc }}
            </v-btn>
          </v-btn-toggle>
        </v-flex>
        <v-flex
          xs12
          md12
          lg12>
          <MaglinkComponentLoadingBar
            :loading="progressBar.loading"
            :indeterminate="false"
            :max-value="progressBar.maxValue"
            :value="progressBar.currentValue" />
          <span>{{ itemCountLabel }}</span>
          <hr>
        </v-flex>
        <v-flex
          xs12
          md12
          lg12
          text-xs-left>
          <span
            class="grey--text font-weight-bold">
            {{ lldDescription }}
          </span>
        </v-flex>
        <v-flex
          v-show="filters.type === 0"
          xs12
          md12>
          <v-data-table
            :headers="headers0"
            :items="dataSource"
            :no-data-text="`${ Maglink.NoDataMessage(false) }`"
            :no-results-text="`${ Maglink.NoDataMessage(true) }`"
            hide-actions>
            <template
              slot="items"
              slot-scope="{ index, item }">
              <tr
                :style="{backgroundColor: backColor(index, item) }"
                class= "text-xs-left">
                <td class="text-xs-right font-weight-bold grey--text">{{ item[0] }}</td>
                <td
                  :style="rowStyle(index, item)"
                  class="text-xs-center"> {{ item[1] }}</td>
                <td class="text-xs-left">{{ item[2] }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
        <v-flex
          v-show="filters.type === 1"
          xs12
          md12>
          <v-data-table
            :headers="headers"
            :items="dataSource12months"
            :no-data-text="`${ Maglink.NoDataMessage(false) }`"
            :no-results-text="`${ Maglink.NoDataMessage(true) }`"
            hide-actions>
            <template
              slot="headerCell"
              slot-scope="{ header }">
              <span
                class="dover-light-blue-color"
                v-text="header.text" />
            </template>
            <template
              slot="items"
              slot-scope="{ index, item }">
              <tr
                :style="{backgroundColor: backColor(index, item) }"
                class="text-xs-left">
                <td class="text-xs-left">{{ item[0] }}</td>
                <td class="text-xs-left">{{ item[1] }}</td>
                <td
                  class="text-xs-left"
                  width="50%">{{ item[2] }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </v-form>
</template>

<script>
export default {
  props: {
    tanks: {
      type: Array,
      required: true,
      default: () => []
    },
    llds: {
      type: Array,
      required: true,
      default: () => []
    },
    systemSettings: {
      type: Object,
      required: true,
      default: () => {}
    },
    options: {
      type: Object,
      required: true,
      default: () => {}
    },
    siteInfo: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  data: () => ({
    isValidationOk: false,
    progressBar: {
      loading: false,
      maxValue: 100,
      currentValue: 0
    },
    rules: {
      isDate: [ v => true ]
    },
    headers0: [],
    headers: [],
    leakUdm: '',
    lldDescription: '',
    dataSource: [],
    dataSource12months: [],
    reportTypes: [],
    selectedDay: '',
    today: '',
    maxDateOfZone: '',
    consoleTimezoneCode: '',
    localeTimezoneCode: '',
    isZoneDifferent: false,
    reportZone: 0,
    reportZones: [],
    filters: {
      all: false,
      number: 1,
      fromDay: '',
      toDay: '',
      timeZoneOffset: 0,
      type: 0 // 0 -“last test”, 1 - “annual”
    }
  }),
  computed: {
    maxDate () {
      return this.maxDateOfZone
    }
  },
  mounted () {
    this.maxDateOfZone = this.dateFromToday(0)

    this.today = this.Maglink.GetCurrentDate()
    this.selectedDay = this.today
    this.filters.toDay = this.today
    this.filters.fromDay = '2000-01-02'
    this.filters.timeZoneOffset = this.Maglink.OffsetToLocalTime

    this.reportTypes.push({ id: 0, desc: this.$t('Last test') })
    this.reportTypes.push({ id: 1, desc: this.$t('Last year') })
    this.leakRateUdm = this.options.volumeUnits[this.systemSettings.volumeUnit || 0].desc + '/' + this.$t('H').toLowerCase()
    this.fillHeaders()

    this.reportZones.push({ code: 0, desc: this.$t('Local (PC)') })
    this.reportZones.push({ code: 1, desc: this.$t('Maglink LX') })

    this.Maglink.GetTimezone()
      .then(response => {
        this.consoleTimezoneCode = response.data.current
        this.localeTimezoneCode = Intl.DateTimeFormat().resolvedOptions().timeZone
        let now = (new Date()).getTime() / 1000
        this.isZoneDifferent = false
        if (this.Maglink.GetCustomDateTimeInZone(now, this.consoleTimezoneCode, 'yyyy-mm-dd') !== this.Maglink.GetCustomDateTimeInZone(now, this.localeTimezoneCode, 'yyyy-mm-dd')) {
          this.isZoneDifferent = true
        }
      })
      .catch(error => this.snack('error', error.message))
  },
  methods: {
    backColor (index, item) {
      if (this.filters.type === 0) {
        return ((index === 0 || index === 3 || (index === 6 && this.selectedDay === this.today)) ? 'transparent' : '#cfdbfb')
      }
      return ((index % 2 === 0) ? '#cfdbfb' : 'transparent')
    },
    rowStyle (index, item) {
      if (this.filters.type === 0) {
        return ((index === 0 || index === 3 || (index === 6 && this.selectedDay === this.today)) ? 'color: #becaea; font-weight:bold;' : '')
      }
      return ''
    },
    leakLabel (leakValue) {
      var label = '' + this.Maglink.RoundFormat(this.Maglink.LeakageToDisplay(leakValue, this.systemSettings.volumeUnit), this.systemSettings.volumeUnit === 0 ? 2 : 1)
      label += ' ' + this.Maglink.LeakShortUdm(this.systemSettings.volumeUnit || 0)
      return label
    },
    leakLabelFromGph (leakValue) {
      return this.leakLabel(leakValue * 3.78541)
    },
    fillHeaders () {
      this.headers = [
        { sortable: false, text: this.$t('Month'), align: 'left' },
        { sortable: false, text: this.$t('Test type') + ' (' + this.leakRateUdm + ')', align: 'left' },
        { sortable: false, text: this.$t('Date'), align: 'left' }
      ]
    },
    onChangeReportType () {
      // this.dataSource = []
      this.fillHeaders()
    },
    onChangeZone () {
      this.dataSource = []
      this.dataSource12months = []
      var date = this.Maglink.GetCustomDateTimeInZone((new Date()).getTime() / 1000, this.reportZone === 0 ? this.consoleTimezoneCode : this.localeTimezoneCode, 'yyyy-mm-dd')
      this.today = date.substr(0, 10)
      this.maxDateOfZone = new Date(date.substr(0, 4) * 1, date.substr(5, 2) * 1 - 1, date.substr(8, 2) * 1)
    },
    applyFilter () {
      if (!this.onCheckDates()) return

      this.getDataSource()
    },
    setLldDescription (lldNumber) {
      for (var i = 0; i < this.llds.length; i++) {
        if (this.llds[i].lldNumber === lldNumber) {
          this.lldDescription = this.llds[i].lldDescription
          return
        }
      }
      this.lldDescription = ''
    },
    dateTimeFormatted (timestamp) {
      if (timestamp !== undefined && timestamp !== 0) {
        if (this.reportZone === 0) { // locale zone
          return this.Maglink.GetCustomDateTime(timestamp, this.systemSettings.dateFormat)
        } else {
          return this.Maglink.GetCustomDateTimeInZone(timestamp, this.consoleTimezoneCode, this.systemSettings.dateFormat)
        }
      }
      return '-'
    },
    getDataSource () {
      this.progressBar.loading = true
      this.dataSource = []
      this.dataSource12months = []
      this.setLldDescription(this.filters.number)

      if (this.reportZone === 0) {
        this.filters.timeZoneOffset = this.Maglink.OffsetToLocalTime
      } else {
        this.filters.timeZoneOffset = 25 // special value to force Maglink LX time zone
      }

      this.filters.all = false
      this.Maglink.GetReportComplianceLld(this.filters)
        .then(response => {
          let reports
          this.dataSource = []
          this.dataSource12months = []

          reports = response.data[0]

          if (this.selectedDay === this.today) {
            this.dataSource.push(['', this.$t('Today'), ''])
          } else {
            this.dataSource.push(['', this.Maglink.GetCustomDate(new Date(this.selectedDay), this.systemSettings.dateFormat), ''])
          }
          this.dataSource.push([this.leakLabelFromGph(3.0) + ' ' + this.$t('PASS'), reports.today3gphPassCount, ''])
          this.dataSource.push([this.leakLabelFromGph(3.0) + ' ' + this.$t('LEAK'), reports.today3gphFailCount, ''])
          if (this.selectedDay === this.today) {
            this.dataSource.push(['', this.$t('Last 24 hours'), ''])
            this.dataSource.push([this.leakLabelFromGph(3.0) + ' ' + this.$t('PASS'), reports.last24h3gphPassCount, ''])
            this.dataSource.push([this.leakLabelFromGph(3.0) + ' ' + this.$t('LEAK'), reports.last24h3gphFailCount, ''])
          }
          var day = Math.floor(new Date(this.today).getTime() / (1000 * 24 * 60 * 60))

          this.dataSource.push(['', this.$t('Last passed test'), ''])
          this.dataSource.push([this.leakLabelFromGph(3.0), this.dateTimeFormatted(reports.last3gphPassDate), (this.reportZone === 0 && reports.last3gphPassDate !== undefined && reports.last3gphPassDate !== 0) ? (day - Math.floor((reports.last3gphPassDate + this.filters.timeZoneOffset * 60 * 60) / (24 * 60 * 60))) + ' ' + this.$t('days ago') : ''])
          this.dataSource.push([this.leakLabelFromGph(0.2), this.dateTimeFormatted(reports.last02gphPassDate), (this.reportZone === 0 && reports.last02gphPassDate !== undefined && reports.last02gphPassDate !== 0) ? (day - Math.floor((reports.last02gphPassDate + this.filters.timeZoneOffset * 60 * 60) / (24 * 60 * 60))) + ' ' + this.$t('days ago') : ''])
          this.dataSource.push([this.leakLabelFromGph(0.1), this.dateTimeFormatted(reports.last01gphPassDate), (this.reportZone === 0 && reports.last01gphPassDate !== undefined && reports.last01gphPassDate !== 0) ? (day - Math.floor((reports.last01gphPassDate + this.filters.timeZoneOffset * 60 * 60) / (24 * 60 * 60))) + ' ' + this.$t('days ago') : ''])

          reports = response.data[0].last12MonthsBestPass
          this.progressBar.maxValue = reports.length

          var monthDate = new Date(this.filters.toDay)
          monthDate.setDate(1)
          for (var i = 0; i < reports.length; i++) {
            let item = reports[i]
            this.progressBar.currentValue = i

            if (typeof item.date === 'string') {
              item.date = new Date(item.date)
            }

            let monthName = this.Maglink.GetMonthName(monthDate) + ' ' + monthDate.getFullYear()
            monthDate.setMonth(monthDate.getMonth() - 1)
            this.dataSource12months.push([monthName, (item.date !== undefined && item.date !== 0) ? this.leakLabel(item.userLeakRateThreshold) : '-', this.dateTimeFormatted(item.date)])
          }
          this.progressBar.loading = false
        })
        .catch(error => {
          this.progressBar.loading = false
          this.snack('error', error.message)
        })
    },
    csvExport (sep) {
      let fileContent = ''

      if (this.siteInfo.name) {
        fileContent += this.siteInfo.name + '\n'
      }
      if (this.siteInfo.header1) {
        fileContent += this.siteInfo.header1 + '\n'
      }
      if (this.siteInfo.header2) {
        fileContent += this.siteInfo.header2 + '\n'
      }
      if (this.siteInfo.header3) {
        fileContent += this.siteInfo.header3 + '\n'
      }

      let title = this.$t('Line') + ' ' + this.filters.number
      let reportTypeDesc = this.$t('Compliance') + ': ' + this.reportTypes[0].desc
      fileContent += reportTypeDesc + '\n' + title + sep
      fileContent += this.lldDescription + '\n'
      fileContent += this.$t('Date') + sep
      fileContent += this.Maglink.GetCustomDate(new Date(this.today), this.systemSettings.dateFormat) + '\n'
      fileContent += '\n'

      fileContent += this.getHeadearsToExport(0, sep)
      for (let index = 0; index < this.dataSource.length; index++) {
        for (let item = 0; item < this.dataSource[index].length; item++) {
          fileContent += this.dataSource[index][item] + sep
        }
        fileContent += '\n'
      }
      fileContent += '\n'

      let reportTypeDesc12 = this.$t('Compliance') + ': ' + this.reportTypes[1].desc
      fileContent += reportTypeDesc12 + '\n' + title + sep
      fileContent += this.lldDescription + '\n'
      fileContent += '\n'

      fileContent += this.getHeadearsToExport(1, sep)
      for (let index = 0; index < this.dataSource12months.length; index++) {
        for (let item = 0; item < this.dataSource12months[index].length; item++) {
          fileContent += this.dataSource12months[index][item] + sep
        }
        fileContent += '\n'
      }
      fileContent += '\n'

      let filename = this.$t('Line Compliance report') + '__' + title
      filename += '__' + this.selectedDay
      filename += '.csv'

      const link = this.Maglink.GetDownloadLinkCSV(fileContent, filename)
      document.body.appendChild(link)
      link.click()
    },
    getHeadearsToExport (type, sep) {
      if (type === 0) {
        return ''
      }
      let fileContent = ''
      for (let index = 0; index < this.headers.length; index++) {
        fileContent += this.headers[index].text + sep
      }
      fileContent += '\n'

      return fileContent
    },
    dateFromToday (days) {
      var currentDate = new Date()
      currentDate.setDate(currentDate.getDate() + days)

      return currentDate
    },
    getDateLabel (value) {
      return this.$t(value) + ' (' + this.$t(this.systemSettings.dateFormat) + ')'
    },
    onCheckDates () {
      // no check if one date is missing
      if (this.filters.toDay === undefined) return true

      if (this.filters.fromDay > this.filters.toDay) {
        this.isValidationOk = false
        this.rules.isDate = [this.$t('Wrong date value')]
      } else {
        this.rules.isDate = [ v => true ]
        this.isValidationOk = true
        this.$refs.form.resetValidation()
      }

      return this.isValidationOk
    },
    onGetDate (componentKey, day) {
      this.dataSource = []
      this.dataSource12months = []
      this.selectedDay = day

      this.filters.toDay = this.selectedDay
    },
    snack (color, message) {
      message = this.$t('Compliance') + ': ' + message
      this.$store.dispatch('showSnackbar', { color, message, show: true })
    }
  }
}
</script>
